// 금액 형식 변경
export const formatCost = (text) => {
  let result = "";
  if(text) {
    result =  String(text).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  return result;
}

// 메뉴 상태 유형
export const formatMenuStatus = (number) => {
  const list = ["판매", "판매 중지", "품절"];
  let result = "";

  if(number) {
    result = list[number - 1]
  }

  return result;
}

// 요일 유형
export const formatDay = (number) => {
  const list = ["월", "화", "수", "목", "금", "토", "일"];
  let result = "";

  if(number) {
    result = list[number - 1]
  }

  return result;
}

// 주문 상태 유형
export const orderTypeFormat = (number) => {
  const list = ["전체", "접수중", "조리중", "배달중", "포장완료", "픽업완료", "배달완료", "주문취소"];
  let result = "";

  if (number !== undefined && number !== null) {
    result = list[number];
  }

  return result;
}

// 배달 유형
export const deliTypeFormat = (number) => {
  const list = ["전체", "배달", "방문포장"];
  let result = "";

  if (number !== undefined && number !== null) {
    result = list[number];
  }

  return result;
}

export const cancelTypeFormat = (number) => {
  const list = [
    "배달불가지역",
    "메뉴 및 업소정보 다름",
    "재료소진",
    "배달지연",
    "고객정보 부정확",
    "고객요청",
    "단순변심",
    "잘못된주문",
    "품절",
    "중복예약",
    "예약정보변경",
    "기타"
  ];
  let result = "";

  if(number) {
    result = list[number - 1]
  }

  return result;
}

// 수수료 타입
export const feeTypeFormat = (number) => {
  const list = ["", "가맹비A 타입", "수수료 타입", "가맹점B 타입"];
  let result = "";

  if (number !== undefined && number !== null) {
    result = list[number];
  }

  return result;
}
